import downloadPdf from './pdf'
import downloadCsv from './csv'

export default {
  downloadPdf,
  downloadCsv,
}
